export default {
  add: 'Добавить',
  save: 'Сохранить',
  edit: 'Редактировать',
  create: 'Создать',
  delete: 'Удалить',
  rename: 'Переименовать',
  reset: 'Сбросить',
  resetAll: 'Сбросить все',
  continue: 'Продолжить',
  ok: 'Ok',
  cancel: 'Отмена',
  accept: 'Принять',
  forward: 'Вперед',
  back: 'Назад',
  complete: 'Выполнить',
  backToHome: 'Вернуться на главную',
  next: 'Далее',
  search: 'Поиск',
  sort: 'Сортировать',
  select: 'Выбрать',
  selectAll: 'Выделить все',
  addFile: 'Добавить файл',
  attachFile: 'Прикрепить файл',
  attachFiles: 'Прикрепить файлы',
  attachments: 'Приложения',
  unsavedChanges:
    'Вы действительно хотите перейти на новую страницу? Все несохраненные данные будут утеряны!',
  openSideMenu: 'Открыть боковое меню',
  saveChanges: 'Сохранить изменения',
  call: 'Позвонить',
  close: 'Закрыть',
  apply: 'Применить',
  upload: 'Загрузить',
  addField: 'Добавить поле',
  addPhone: 'Добавить телефон',
  addNewContact: 'Добавить новый контакт',
  closeUnsavedChanges: 'Закрыть панель фильтров и сбросить несохраненные изменения',
  expand: 'Раскрыть',
  compressingPhoto: 'Идет процесс сжатия фото...',
  photoUploadSuccess: 'Фотографии успешно добавлены',
  documentUploadSuccess: 'Документы успешно добавлены',
  goTo: 'Перейти',
  gotIt: 'Понятно',
  sendToEmail: 'Отправить на почту',
  downloadFile: 'Скачать файл',
  selectAction: 'Выберите действие',
  attachedFileWasSent: 'Письмо с файлом отправлено на почту',
  downloadedFile: 'Файл скачан',
  addNewEmail: 'Добавить новый почтовый ящик',
  refresh: 'Обновить',
  showOn: 'Показать на',
  sendAnalytics: 'Отправить аналитику',
  calculate: 'Рассчитать',
  successCopyToClipboard: 'успешно скопирован в буфер обмена',
  toShare: 'Поделиться',
};
